var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-letter"},[_c('v-img',{staticClass:"letter-img",attrs:{"src":require("../assets/img/portfolio-letter.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }